import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", stroke: "currentcolor", fill: "none", strokeWidth: 2, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgClock);
export default ForwardRef;
